export default __webpack_public_path__ + "img/reward.130bd61.svg";